import script from "./PaperPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperPublish.vue?vue&type=script&setup=true&lang=js"

import "./PaperPublish.vue?vue&type=style&index=0&id=c456eacc&lang=scss"

const __exports__ = script;

export default __exports__